<template>
  <v-card>
    <v-card-title>
      <strong>
        <small>{{ mealItem.total }}x</small>
        {{ mealItem.name }}
      </strong>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <template v-for="(shiftConfig, sIndex) in shiftDisplayConfig">
        <template
          v-if="
            mealItem[shiftConfig.usersKey] &&
            mealItem[shiftConfig.usersKey].length &&
            selectedShifts.includes(shiftConfig.id)
          "
        >
          <h3
            class="mb-4 black--text"
            :class="{
              'mt-8': isNotFirstVisibleShift(mealItem, sIndex),
            }"
            :key="`title-${sIndex}`"
          >
            <small>{{ mealItem[shiftConfig.totalKey] }}x</small>
            {{ $t(shiftConfig.nameKey) }}
          </h3>
          <v-row :key="`row-${sIndex}`">
            <v-col
              cols="auto"
              v-for="(user, uIndex) in mealItem[shiftConfig.usersKey]"
              :key="uIndex"
            >
              <strong class="black--text">{{ user.quantity }}x</strong>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ toLatin(user.name) }}
                    {{ toLatin(user.lastname) }}
                  </span>
                </template>
                <span>{{ user.id }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ReportMealsOrderCard",
  props: {
    mealItem: {
      type: Object,
      required: true,
    },
    shiftDisplayConfig: {
      type: Array,
      required: true,
    },
    selectedShifts: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isNotFirstVisibleShift(mealItem, currentIndex) {
      const firstVisibleIndex = this.shiftDisplayConfig.findIndex(
        (sc) =>
          mealItem[sc.usersKey] &&
          mealItem[sc.usersKey].length &&
          this.selectedShifts.includes(sc.id)
      );
      return firstVisibleIndex !== -1 && currentIndex > firstVisibleIndex;
    },
    // translate method is expected to be available from a global mixin
  },
};
</script>
